import type { ProductType } from "@lending/navigation";

const MEMBERSHIP_SHARE_ENDPOINTS = {
  memberships: {
    "personal-loan": "/v2/lending/personal_loan_applications/{uuid}/memberships/",
    "credit-card": "/v2/lending/credit_card_applications/{uuid}/memberships/",
    "auto-loan": "/v2/lending/vehicle_loan_applications/{uuid}/memberships/",
  },
  membership_selection: {
    "personal-loan": "/v2/lending/personal_loan_applications/{uuid}/membership_selection/",
    "credit-card": "/v2/lending/credit_card_applications/{uuid}/membership_selection/",
    "auto-loan": "/v2/lending/vehicle_loan_applications/{uuid}/membership_selection/",
  },
  membership_account_application: {
    "personal-loan":
      "/v2/lending/personal_loan_applications/{uuid}/membership_account_application/",
    "credit-card": "/v2/lending/credit_card_applications/{uuid}/membership_account_application/",
    "auto-loan": "/v2/lending/vehicle_loan_applications/{uuid}/membership_account_application/",
  },
  membership_share_primary_email: {
    "personal-loan":
      "/v2/lending/personal_loan_applications/{uuid}/membership_share_primary_email/",
    "credit-card": "/v2/lending/credit_card_applications/{uuid}/membership_share_primary_email/",
    "auto-loan": "/v2/lending/vehicle_loan_applications/{uuid}/membership_share_primary_email/",
  },
  membership_share_access: {
    "personal-loan": "/v2/lending/personal_loan_applications/{uuid}/membership_share_access/",
    "credit-card": "/v2/lending/credit_card_applications/{uuid}/membership_share_access/",
    "auto-loan": "/v2/lending/vehicle_loan_applications/{uuid}/membership_share_access/",
  },
} as const;

type MembershipShareEndpointKind = keyof typeof MEMBERSHIP_SHARE_ENDPOINTS;
type MembershipShareEndpoint<K extends MembershipShareEndpointKind> =
  (typeof MEMBERSHIP_SHARE_ENDPOINTS)[K][ProductType];

// Returns the correct lending membership-share API endpoint for the current product.
// We throw instead of falling back to a default route so missing or unknown product types fail loudly.
function getMembershipShareEndpoint<K extends MembershipShareEndpointKind>(
  productType: ProductType | null,
  kind: K
): MembershipShareEndpoint<K> {
  if (!productType) {
    throw new Error(`Membership share ${kind} endpoint is unavailable without an application type`);
  }

  const endpoint = MEMBERSHIP_SHARE_ENDPOINTS[kind][productType];

  if (!endpoint) {
    throw new Error(
      `Membership share ${kind} endpoint is unavailable for application type: ${productType}`
    );
  }

  return endpoint as MembershipShareEndpoint<K>;
}

export { getMembershipShareEndpoint };
